import { useGetMcpServersByAppIdQuery } from '../../../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpServerRegistryRpc.hooks';
export function useGetMcpServer({
  appContext,
  isMcpServer,
  sourceId
}) {
  var _data$mcpServers, _data$mcpServers2;
  const {
    data,
    loading
  } = useGetMcpServersByAppIdQuery({
    variables: {
      appId: sourceId !== null && sourceId !== void 0 ? sourceId : 0
    },
    skip: !isMcpServer || appContext !== 'app' || !sourceId
  });
  return {
    matchingMcpServer: data === null || data === void 0 || (_data$mcpServers = data.mcpServers) === null || _data$mcpServers === void 0 ? void 0 : _data$mcpServers[0],
    loading,
    visibility: data === null || data === void 0 || (_data$mcpServers2 = data.mcpServers) === null || _data$mcpServers2 === void 0 || (_data$mcpServers2 = _data$mcpServers2[0]) === null || _data$mcpServers2 === void 0 ? void 0 : _data$mcpServers2.visibility
  };
}